// Category taxonomy used across scoring, dashboard cards, and recommendations
export const CATEGORIES = [
  { key: 'governance', label: 'AI Governance' },
  { key: 'dlp', label: 'Data Protection' },
  { key: 'adoption', label: 'Enterprise AI Adoption' },
  { key: 'agents', label: 'AI Agents' },
  { key: 'security', label: 'Security' },
];

// Each question (except the challenge question) carries a `weights` map:
// { categoryKey: relativeWeight }. The scoring engine turns the selected
// option index into a 0-100% value, then folds it into each listed
// category using that weight. Q9 is personalization-only and carries no
// weights, so it never affects the score.
//
// Every question also ends with an "Others" option. When a user selects it,
// QuestionCard renders a free-text box beneath the options so they can enter
// something not covered by the preset list (see `otherText` handling in
// Assessment.jsx / QuestionCard.jsx).
export const questions = [
  {
    id: 'q1',
    number: 1,
    title: 'How is AI currently used across your organization?',
    type: 'multi',
    options: [
      "We don't use AI",
      'A few employees use public AI tools',
      'Multiple teams use AI',
      'AI is integrated into business workflows',
      'AI is a strategic capability',
      'Others',
    ],
    weights: { adoption: 1, security: 0.3 },
  },
  {
    id: 'q2',
    number: 2,
    title: 'Which AI technologies are currently used?',
    type: 'multi',
    options: [
      'ChatGPT / Gemini / Claude',
      'GitHub Copilot / Cursor',
      'Self-hosted AI',
      'Internal AI applications',
      'AI Agents',
      'Others',
    ],
    weights: { adoption: 0.8, agents: 0.6, security: 0.4 },
  },
  {
    id: 'q3',
    number: 3,
    title: 'How does your organization protect sensitive data when using AI?',
    type: 'multi',
    options: [
      'No controls',
      'Employee awareness',
      'Basic DLP',
      'AI-aware DLP',
      'Fully governed AI interactions',
      'Others',
    ],
    weights: { dlp: 1, security: 0.5 },
  },
  {
    id: 'q4',
    number: 4,
    title: 'Does your organization have an AI Governance policy?',
    type: 'multi',
    options: ['No', 'Planning', 'Partially implemented', 'Implemented', 'Fully monitored', 'Others'],
    weights: { governance: 1 },
  },
  {
    id: 'q5',
    number: 5,
    title: 'Can employees upload confidential information to public AI tools?',
    type: 'multi',
    options: [
      'Yes without restrictions',
      'Discouraged',
      'Approved users only',
      'Approved enterprise AI only',
      'Completely blocked',
      'Others',
    ],
    weights: { dlp: 1, governance: 0.4 },
  },

  // {
  //   id: 'q6',
  //   number: 6,
  //   title: 'Are AI Agents currently used?',
  //   type: 'multi',
  //   options: ['No', 'Experiments', 'Few teams', 'Multiple departments', 'Core business operations', 'Others'],
  //   weights: { agents: 1 },
  // },
  // {
  //   id: 'q7',
  //   number: 7,
  //   title: 'How are AI-generated outputs reviewed?',
  //   type: 'multi',
  //   options: ['No review', 'Manual review', 'Team approval', 'Automated governance', 'Full audit logging', 'Others'],
  //   weights: { governance: 0.6, security: 0.6 },
  // },
  // {
  //   id: 'q8',
  //   number: 8,
  //   title: 'How are AI tools managed?',
  //   type: 'multi',
  //   options: [
  //     'Anyone can use anything',
  //     'IT recommendations',
  //     'Approved tools',
  //     'Centralized platform',
  //     'Centralized governance',
  //     'Others',
  //   ],
  //   weights: { governance: 0.7, security: 0.5 },
  // },
  // {
  //   id: 'q9',
  //   number: 9,
  //   title: 'What is your biggest AI challenge?',
  //   type: 'multi',
  //   options: [
  //     'Security',
  //     'Data Privacy',
  //     'Compliance',
  //     'AI Agents',
  //     'Integration',
  //     'Cost',
  //     'Employee Adoption',
  //     'Others',
  //   ],
  //   weights: {}, // personalization only — does not affect score
  //   personalizationOnly: true,
  // },
  // {
  //   id: 'q10',
  //   number: 10,
  //   title: "What is your organization's AI vision?",
  //   type: 'multi',
  //   options: ['Exploring AI', 'Pilot Projects', 'Scaling AI', 'Enterprise Transformation', 'AI First', 'Others'],
  //   weights: { adoption: 1, agents: 0.3 },
  // },
];
